import { Image } from '@chakra-ui/react';
import React from 'react';

import PppLearningLogo from '../../../../assets/icons/3p_learning.svg';
import { useSelectorIsOneRosterActivatedSchool } from '../../../app';
import { useSelectorLeftNavButtons } from '../../../user-profiles';
import {
    LeftNavButton, LeftNavButtonProps
} from './components/left-nav-button';
import { useLeftNavButton } from './hooks';
import {
    LeftNavBackground, ProductLogo
} from './left-nav.styled';

export type LeftButtons = Omit<LeftNavButtonProps, 'onOpenModule'>;

/**
 * The main left navigation menu of the Portal application. This component is
 * also responsible for deciding which module link to show based on the product ids
 * it is associated with and the current product active in the app.
 */
export const LeftNav = () => {
    const {
        getLeftNavButtonProps,
        getHomeNavButtonProps
    } = useLeftNavButton();
    const buttons = useSelectorLeftNavButtons();
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const renderLeftNavButtons = (buttons: Array<LeftButtons>) => (
        buttons.map((buttonProps: LeftButtons) => {
            // useSelectorLeftNavButtons filters by product Id... if no modules exist we pass a null moduleId
            if (!buttonProps.moduleId) {
                return null;
            }

            return (
                <LeftNavButton
                    {...getLeftNavButtonProps(buttonProps)}
                    key={`button-${buttonProps.moduleId}`}
                />
            );
        })
    );

    if (buttons.length === 0) {
        return null;
    }

    return (
        <LeftNavBackground role={'menu'} data-testid={'left-nav'}>
            <LeftNavButton {...getHomeNavButtonProps()} />
            {renderLeftNavButtons(buttons)}
            { isOneRosterActivatedSchool &&
            <ProductLogo>
                <Image w={'80%'} src={PppLearningLogo} alt={'3P'} />
            </ProductLogo>
            }
        </LeftNavBackground>
    );
};
